<template>
  <BaseSlideOverModal
    :is-modal-open="open"
    :title="
      $t(
        item
          ? 'global.commission_note_line_edit_title'
          : 'global.commission_note_add_title'
      )
    "
    width="3xl"
    hide-close-button
    tracking-name="CommissionNoteAddSlideOver"
    @close="$emit('close')"
    @update:is-modal-open="$emit('update:open', $event)"
  >
    <template #subtitle>
      <p class="mt-1 text-sm text-gray-500">
        <span class="font-semibold text-gray-700 dark:text-gray-200">
          {{ commissionNote.reference }}
        </span>
        <template v-if="commissionNote.advisor?.full_name">
          · {{ commissionNote.advisor.full_name }}
        </template>
        <template v-if="commissionNote.funeral_home?.name">
          · {{ commissionNote.funeral_home.name }}
        </template>
        <template v-if="commissionNote.period_label">
          · {{ commissionNote.period_label }}
        </template>
      </p>
    </template>
    <template #body>
      <div class="flex min-h-0 w-full flex-col gap-4">
        <div
          v-if="!item"
          class="flex shrink-0 flex-row gap-1 rounded-lg bg-slate-100 p-1 dark:bg-slate-700"
          role="tablist"
        >
          <button
            v-for="tab in tabs"
            :key="tab.key"
            type="button"
            role="tab"
            class="flex flex-1 flex-row items-center justify-center gap-2 rounded-md px-3 py-2 text-sm font-semibold"
            :class="{
              'bg-white text-primary shadow-sm dark:bg-slate-900':
                currentTab === tab.key,
              'text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-gray-100':
                currentTab !== tab.key
            }"
            :aria-selected="currentTab === tab.key"
            :data-tab="tab.key"
            @click="currentTab = tab.key"
          >
            <FontAwesomeIcon :icon="['fal', tab.icon]" />
            <!-- the label is its own block: the capital letter does not apply to the text of a flex container -->
            <span class="capitalize-first">{{ $t(tab.label) }}</span>
          </button>
        </div>
        <div class="flex min-h-0 flex-1">
          <CommissionNoteItemForm
            v-if="item || currentTab === 'free'"
            :commission-note-id="commissionNote.id"
            :item="item"
            :submit-label="item ? null : $t('button.add_line')"
            @saved="saved"
            @cancel="$emit('close')"
          />
          <CommissionNoteDocumentsPicker
            v-else
            :commission-note-id="commissionNote.id"
            :period="{
              start: commissionNote.period_start,
              end: commissionNote.period_end
            }"
            @saved="saved"
            @cancel="$emit('close')"
          />
        </div>
      </div>
    </template>
    <template #cta><span /></template>
  </BaseSlideOverModal>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import BaseSlideOverModal from '@c/addf-package/components/modal/BaseSlideOverModal.vue'
import CommissionNoteDocumentsPicker from '@/views/invoicing/show/commissionNote/components/CommissionNoteDocumentsPicker.vue'
import CommissionNoteItemForm from '@/views/invoicing/show/commissionNote/components/CommissionNoteItemForm.vue'

/**
 * Changes an open note from the right: adds a free line or the commission of
 * documents of the advisor, or edits a line. The note is shown on top.
 */
export default {
  name: 'CommissionNoteAddSlideOver',
  components: {
    BaseSlideOverModal,
    CommissionNoteDocumentsPicker,
    CommissionNoteItemForm,
    FontAwesomeIcon
  },
  props: {
    open: { type: Boolean, required: true },
    commissionNote: { type: Object, required: true },
    /** The line to edit, nothing to add */
    item: { type: Object, default: null },
    /** 'documents' or 'free' */
    initialTab: { type: String, default: 'documents' }
  },
  emits: ['update:open', 'close', 'saved'],
  data() {
    return {
      currentTab: this.initialTab,
      tabs: [
        {
          key: 'documents',
          icon: 'file-invoice',
          label: 'global.commission_note_tab_documents'
        },
        {
          key: 'free',
          icon: 'pen',
          label: 'global.commission_note_tab_free_line'
        }
      ]
    }
  },
  methods: {
    saved(commissionNote) {
      this.$emit('saved', commissionNote)
      this.$emit('close')
    }
  }
}
</script>
